const NOTIFY_SOUND_SRC = "/sounds/notify.mp3";
const ENABLE_SPEECH_FALLBACK = true;

let audioInstance = null;
let unlocked = false;
let lastPlayAt = 0;

const createAudio = () => {
    if (audioInstance) return audioInstance;

    audioInstance = new Audio(NOTIFY_SOUND_SRC);
    audioInstance.preload = "auto";
    audioInstance.volume = 0.35;

    return audioInstance;
};

export const unlockNotifyAudio = async () => {
    if (unlocked) return true;

    try {
        const audio = createAudio();

        audio.muted = true;
        audio.currentTime = 0;

        await audio.play();

        audio.pause();
        audio.currentTime = 0;
        audio.muted = false;

        unlocked = true;

        return true;
    } catch (_error) {
        return false;
    }
};

export const playDing = async () => {
    try {
        const now = Date.now();

        if (now - lastPlayAt < 350) return true;

        lastPlayAt = now;

        const audio = createAudio();

        audio.pause();
        audio.currentTime = 0;
        audio.muted = false;
        audio.volume = 0.35;

        await audio.play();

        unlocked = true;

        return true;
    } catch (_error) {
        return false;
    }
};

export const speak = (text = "Новое уведомление") => {
    try {
        if (!ENABLE_SPEECH_FALLBACK) return false;
        if (typeof window === "undefined") return false;
        if (!("speechSynthesis" in window)) return false;

        const utterance = new SpeechSynthesisUtterance(text);

        utterance.lang = "ru-RU";
        utterance.volume = 0.75;
        utterance.rate = 1;

        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(utterance);

        return true;
    } catch (_error) {
        return false;
    }
};

export const initNotifyAudioUnlockListeners = () => {
    if (typeof window === "undefined") return;

    const unlock = () => {
        unlockNotifyAudio();
    };

    window.addEventListener("pointerdown", unlock, { once: true, passive: true });
    window.addEventListener("keydown", unlock, { once: true });
    window.addEventListener("touchstart", unlock, { once: true, passive: true });
};